<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn outlined :icon="!activatorLabel" v-on="on">
          <v-icon :size="iconSize">{{activatorIcon ? activatorIcon:'mdi-plus'}}</v-icon>
          {{activatorLabel}}
        </v-btn>
      </template>

      <v-card height="500" width="100%" class="mx-auto">
        <v-card-title>Find a student</v-card-title>
        <v-card-text class="mt-5">
        <v-autocomplete
          v-model="student"
          :items="students"
          :loading="isAppLoading"
          :search-input.sync="search"
          hide-no-data
          hide-selected
          no-filter
          item-text="label"
          item-value="id"
          label="Search for student by name or email"
          placeholder="Start typing to Search"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>

          <span>Selected Student: {{this.student ? this.student.label:'N/A'}}</span>
        </v-card-text>

        <v-card-text>
          Most recent students:<br/>
          list most recently attended students here...
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="selectedStudent">Select Student</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["activatorIcon", "activatorLabel", "iconSize", "initDialog"],
  data() {
    return {
      dialog: false,
      students: [],
      student: null,
      search: null,
    };
  },
  watch: {
    search(query) {
      console.log(`query ${query} vs selected ${this.student ? this.student.label:''}`)
      let selected = false;
      if(this.student){
        selected = query == this.student.label;
      }

      if (query && query.length > 2 && !selected) {
        // console.log('query DB')
        this.queryStudents(query);
      }
      else{
        // console.log('return null')
        this.students = []
      }
    },
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    queryStudents(term) {
      // cancel pending call
      clearTimeout(this._timerId);

      // delay new call 500ms
      this._timerId = setTimeout(() => {
        this.students = []; //reset customer list
        const data = { searchTerm: term, searchEntities: ["STUDENT"] };
        this.$axios.post("search", data).then(resp => {
          const searchResults = resp.data;
          const students = searchResults.students;
          // console.log('Found Results')
          // console.log(students)
          if (students && students.length > 0) {
            this.students = students.map(s => { return {id: s.id, label: `${s.firstName} ${s.lastName} (${s.email ? s.email:'no email'})`} });
            // console.log(this.students )
          }
        });
      }, 500);
    },
    openDialog(event) {
      this.$emit("onOpen", event);
    },
    selectedStudent() {
      this.$emit("selectedStudent", this.student);
      this.dialog = false;
    }
  },
  mounted() {
    if(this.initDialog){
      this.dialog = this.initDialog;
    }
  }
};
</script>

<style>
</style>